/* eslint-disable */
import MainService from '@/services/MainService';

class ValidationKeyMethods {
  validateKey ({ key, sessionId, customerIdentification, validationType }: { key: string, sessionId: string, customerIdentification: string, validationType: string }): Promise<any> {
    if (!customerIdentification) {
      return Promise.reject(new Error('Customer identification is required'));
    }

    customerIdentification = customerIdentification.replace(/-/g, '');

    if (customerIdentification.length < 15) {
      const zeros = '0'.repeat(15 - customerIdentification.length);
      customerIdentification = zeros + customerIdentification;
    }

    const data = {
      route: 'ocular/rest/integration/key-validation',
      params: <any>{
        validation_type: validationType,
        web_key: key,
        session_id: sessionId,
        identification: customerIdentification
      }
    };

    return MainService.post(data);
  }
}

export default new ValidationKeyMethods();
